<template>
  <v-card
    ref="ppp"
    >
    <v-menu
      v-model="showMenu"
      :position-x="menuX"
      :position-y="menuY"
      absolute
      offset-y
      >
      <v-list dense>
          <!-- @click="clickAction(n)" -->
        <v-list-item
          v-for="(menuItem, n) in menuItems"
          :key="`menuItem_${n}`"
          :to="to_current_item_mod(n)"
          target="_blank"
          >
          <v-list-item-content>
          <v-list-item-title>{{menuItem}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
      <v-list-item-group
        v-model="selected_arti"
        >
        <v-lazy
          v-for="(item, n) in artis"
          :key="`arti_vlazy_${n}`"
          :id="`arti_${item.metano}`"
          :height="itemHeight"
          :min-height="itemMinHeight"
          :max-height="itemMaxHeight"
          :width="itemWidth"
          :min-width="itemMinWidth"
          :max-width="itemMaxWidth"
          :transition="transition"
          >
          <!-- <v-hover
            v-slot="{ hover }"
            :close-delay="0"
            > -->
            <v-list-item
              :value="item.metano"
              :ripple="true"
              :to="to_item(item)"
              target="_blank"
              @contextmenu="on_contextmenu($event, item)"
              >
                <!-- @click="on_contextmenu($event, item)" -->
              <v-list-item-content
                >
                <v-list-item-title>
                  <span class="d-inline-block text-truncate" style="max-width: 600px;" v-text="item.title" />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span class="d-inline-block text-truncate" style="max-width: 600px;" v-text="arti_meta(item)" />
                </v-list-item-subtitle>
              </v-list-item-content>
              <!-- <v-list-item-action v-show="hover || selected_arti==item.metano"> -->
              <!-- <v-list-item-action v-show="false">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      icon
                      tile
                      target="_blank"
                      :to="{ name:'ArticleView', params: { metaNo: item.metano } }"
                      v-on="on"
                      v-bind="attrs"
                      >
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>在新分頁開啟</span>
                  </v-tooltip>
              </v-list-item-action> -->
            </v-list-item>
          <!-- </v-hover> -->
        </v-lazy>
      </v-list-item-group>
  </v-card>
</template>
<script>
import {debug} from 'loglevel'
export default {
  name: "LazyArtis",
  computed: {
    to_current_item() {
      return this.to_item(this.currentItem)
    },
  },
  methods: {
    to_item(i) {
      if(i) {
        const name = 'ArtiView'
        const metaNo = i.metano
        const uniname = metaNo.slice(0, 3)
        const query = this.$q()
        const to = {name, params: {uniname, metaNo}, query}
        return to
      }
      return undefined
    },
    to_current_item_mod(n) {
      const to = Object.assign({}, this.to_current_item)
      if(!to) return undefined
      to.params = Object.assign({}, to.params, this.menuMods[n])
      // debug('n/to', n, to)
      return to
    },
    clickAction(n) {
      // debug('clickAction(n)', n)
      const to = this.to_current_item
      const routeData = this.$router.resolve(to)
      window.open(routeData.href, this.menuTargets[n])
    },
    on_contextmenu(e, item) {
      e.preventDefault()
      // debug('i', item)
      this.currentItem = item
      this.showMenu = false;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    arti_meta(i) {
      var mm = []
      if(i.pubtime) {
        mm.push(this.$u.pubtime_str(i.pubtime))
      }
      if(i.volno) {
        mm.push(i.volno)
      }
      if(i.authors) {
        mm.push(i.authors)
      }
      if(i.dynasty) {
        mm.push(i.dynasty)
      }
      const s = mm.join(' / ')
      return s
    },
  },
  watch: {
    artis() {
      this.selected_arti = undefined
    },
  },
  data() {
    return {
      selected_arti: undefined,
      showMenu: false,
      menuX: 0,
      menuY: 0,
      menuItems: ["在新頁開啟", "開啟文字版面", "開啟文字"],
      menuMods: [{}, {layout: 'ft'}, {layout: 'text'}],
      currentItem: undefined,
    }
  },
  props: {
    artis: {
      type: Array,
      required: true,
    },
    itemHeight: {},
    itemMinHeight: {
      default: 45,
    },
    itemMaxHeight: {},
    itemWidth: {},
    itemMinWidth: {},
    itemMaxWidth: {},
    transition: {},
  },
}
</script>
